<div class="loading-screen-wrapper">
  <div class="holder">
    <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
  </div>
</div>
